import {Flex, Tooltip } from '@chakra-ui/react';
import { Badge } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileLines,
  faEye,
  faEyeSlash,
  faDiagramSubtask,
  faLanguage
} from '@fortawesome/pro-regular-svg-icons';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import { GenericSubmissionField } from 'src/components/Submission/MySubmission/FormFieldGeneric/GenericSubmissionField';

export const SubmissionDetails = () => {
  const { fieldsResponse } = useReviewData();
  const { articleTypeName, fields } = fieldsResponse;

  const isDoubleAnonymous = fields['DoubleAnonymousPeerReview']?.value;

  const articleSubType = fields['ArticleSubtype']?.value as string | undefined;
  const articleLanguage = fields['ArticleLanguage']?.value as
    | string
    | undefined;

  return (
    <Flex flexDirection="column" gap={4}>
      <Flex gap={2}>
        {articleTypeName && (
          <Badge variant="attention" size="context">
            <Flex gap={1} alignItems="center">
              <FontAwesomeIcon icon={faFileLines} />
              {articleTypeName}
            </Flex>
          </Badge>
        )}
        {articleSubType && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Sub Type`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="interactive" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faDiagramSubtask} />
                {articleSubType}
              </Flex>
            </Badge>
          </Tooltip>
        )}
        {articleLanguage && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Language`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="success" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faLanguage} />
                {articleLanguage}
              </Flex>
            </Badge>
          </Tooltip>
        )}
        {isDoubleAnonymous !== undefined && (
          <Badge variant="neutral" size="context">
            <Flex gap={1} alignItems="center">
              <FontAwesomeIcon icon={isDoubleAnonymous ? faEyeSlash : faEye} />
              {isDoubleAnonymous ? 'Double Anonymous' : 'Single Anonymous'}
            </Flex>
          </Badge>
        )}
      </Flex>

      <GenericSubmissionField entryPoint="review" fieldName="Title" />
      <GenericSubmissionField entryPoint="review" fieldName="EnglishTitle" />
      <GenericSubmissionField entryPoint="review" fieldName="Subtitle" />
      <GenericSubmissionField entryPoint="review" fieldName="EnglishSubtitle" />
      <GenericSubmissionField entryPoint="review" fieldName="Abstract" />
      <GenericSubmissionField entryPoint="review" fieldName="EnglishAbstract" />
      <GenericSubmissionField entryPoint="review" fieldName="Keywords" />
      <GenericSubmissionField
        entryPoint="review"
        fieldName="SubmissionGuidelines"
      />
      <GenericSubmissionField entryPoint="review" fieldName="EnglishKeywords" />
      <GenericSubmissionField entryPoint="review" fieldName="ArticleSubtype" />
      <GenericSubmissionField entryPoint="review" fieldName="ArticleLanguage" />

      <GenericSubmissionField entryPoint="review" fieldName="NumberOfFigures" />
      <GenericSubmissionField
        entryPoint="review"
        fieldName="NumberOfColorFigures"
      />
      <GenericSubmissionField entryPoint="review" fieldName="NumberOfTables" />
      <GenericSubmissionField entryPoint="review" fieldName="NumberOfWords" />
      <GenericSubmissionField
        entryPoint="review"
        fieldName="GeneralClassifications"
      />
    </Flex>
  );
};
